/**
 * HTTP Configuration Constants (infra-level)
 * No environment imports, only generic defaults.
 * @module @infra/http
 */

export const HTTP_CONFIG = {
  /**
   * Default timeout for HTTP requests (in milliseconds)
   */
  TIMEOUT: 30000,
} as const;

/**
 * HTTP Headers
 */
export const HTTP_HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  AUTHORIZATION: 'Authorization',
  ACCEPT_LANGUAGE: 'Accept-Language',
  BEARER: 'Bearer',
} as const;

/**
 * HTTP Status Codes
 */
export const HTTP_STATUS = {
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
} as const;

/**
 * HTTP Error Codes
 */
export const HTTP_ERROR_CODES = {
  CONNECTION_ABORTED: 'ECONNABORTED',
  NETWORK_ERROR: 'ERR_NETWORK',
  TIMEOUT: 'ECONNABORTED',
  TIMED_OUT: 'ETIMEDOUT',
} as const;
